import redirect from 'cerebral-module-router/redirect'

import checkIsAdmin from '../actions/checkIsAdmin'
import getUser from '../actions/getUser'
import setAdminClientHelperForCurrentUser
  from '../actions/setAdminClientHelperForCurrentUser'
import setCurrentUser from '../actions/setCurrentUser'
import setDataLoading from '../actions/setDataLoading'
import setDataUnloading from '../actions/setDataUnloading'
import setPageForUserEdit from '../actions/setPageForUserEdit'
import setCommonFieldsForCurrentUser
  from '../actions/setCommonFieldsForCurrentUser'
import setAggregationFieldsForCurrentUser
  from '../actions/setAggregationFieldsForCurrentUser'
import setAddressFieldsForCurrentUser
  from '../actions/setAddressFieldsForCurrentUser'
import resetAllForms from '../factories/resetAllForms'
import validateAllForms from '../factories/validateAllForms'
import isCurrentUserAdmin from '../actions/isCurrentUserAdmin'
import isPreventField from '../factories/isPreventField'
import isPreventAllClientFields from '../factories/isPreventAllClientFields'
import prepareModuleFieldsForCurrentUser
  from '../actions/prepareModuleFieldsForCurrentUser'
import resetSelectedOptions from '../actions/resetSelectedOptions'
import makeFieldRequired from '../factories/makeFieldRequired'
import isRemoteLogin from '../../client/actions/isRemoteLogin'
import setLocaleForCurrentUser from '../actions/setLocaleForCurrentUser'
import setValidFieldsForCurrentUser
  from '../actions/setValidFieldsForCurrentUser'
import initializeFields from 'modules/app/chains/initializeFields'

export default [
  setDataLoading,
  checkIsAdmin,
  {
    false: [redirect('/login')],
    true: [
      getUser,
      {
        success: [
          setCurrentUser,
          {
            isDeleted: [redirect('/users')],
            doesExist: [
              setAdminClientHelperForCurrentUser,
              resetAllForms(),
              resetSelectedOptions,
              ...initializeFields,
              setLocaleForCurrentUser,
              setCommonFieldsForCurrentUser,
              setValidFieldsForCurrentUser,
              setAggregationFieldsForCurrentUser,
              setAddressFieldsForCurrentUser,
              prepareModuleFieldsForCurrentUser,
              isPreventAllClientFields(false),
              isRemoteLogin,
              {
                true: [],
                false: [
                  makeFieldRequired(
                    'client.registrating.current.newPassword.password',
                    false
                  ),
                  makeFieldRequired(
                    'client.registrating.current.newPassword.confirmPassword',
                    false
                  )
                ]
              },
              isCurrentUserAdmin,
              {
                true: [
                  isPreventField(
                    'client.registrating.current.common.validTo',
                    true
                  ),
                  isPreventField(
                    'client.registrating.current.common.validFrom',
                    true
                  )
                ],
                false: [
                  isPreventField(
                    'client.registrating.current.common.validTo',
                    false
                  ),
                  isPreventField(
                    'client.registrating.current.common.validFrom',
                    false
                  )
                ]
              },
              validateAllForms(),
              setPageForUserEdit,
              setDataUnloading
            ]
          }
        ],
        error: [setDataUnloading]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/onPrepareFieldsForEditUser.js